import React from "react";
import cls from "../styles/SolutionHeader.module.scss";
export default function SolutionHeader() {
  return <div className={cls.header} data-sentry-component="SolutionHeader" data-sentry-source-file="SolutionHeader.tsx">
      <div className={cls.header_content}>
        <h1 className={cls.header_title}>QR code Solutions and Services</h1>
        <p className={cls.header_subtitle}>
          Explore comprehensive QR code solutions and services tailored to drive efficiency and
          connectivity.
        </p>
        <ul>
          <li>
            <b>Editable Content: </b> Update information in real-time without generating new codes.
          </li>
          <li>
            <b>Trackable Analytics:</b> Gain insights into consumer behavior and engagement for
            informed decision-making.
          </li>
          <li>
            <b>Customization:</b> Reflect your brand identity with customized colors, shapes, logos,
            and frames.
          </li>
          <li>
            <b>Bulk Generation:</b> Save time with tools that allow creating multiple QR codes at
            once.
          </li>
        </ul>
      </div>
    </div>;
}